import { useState } from 'react';
import './App.css';
import MainPage from './Components/Main/Main';
import AboutUs from './Components/About/AboutUs';
import Services1 from './Components/Services/Services1/Services1';
import Services2 from './Components/Services/Services2/Services2';
import Services3 from './Components/Services/Services3/Services3';
import Services4 from './Components/Services/Services4/Services4';
import Upcoming1 from './Components/Upcoming/Upcoming1/Upcoming1';
import Upcoming2 from './Components/Upcoming/Upcoming2/Upcoming2';
import Upcoming3 from './Components/Upcoming/Upcoming3/Upcoming3';
import Contact from './Components/Contact/Contact';

function App() {
  const [currentPage, setCurrentPage] = useState('main');

  const renderPage = () => {
    switch (currentPage) {
      case 'main':
        return <MainPage onNavigate={setCurrentPage} />;
      case 'about':
        return <AboutUs onNavigate={setCurrentPage} />;
      case 'services1':
        return <Services1 onNavigate={setCurrentPage} />;
      case 'services2':
        return <Services2 onNavigate={setCurrentPage} />;
      case 'services3':
        return <Services3 onNavigate={setCurrentPage} />;
      case 'services4':
        return <Services4 onNavigate={setCurrentPage} />;
      case 'upcoming1':
        return <Upcoming1 onNavigate={setCurrentPage} />;
      case 'upcoming2':
        return <Upcoming2 onNavigate={setCurrentPage} />;
      case 'upcoming3':
        return <Upcoming3 onNavigate={setCurrentPage} />;
      case 'contact':
        return <Contact onNavigate={setCurrentPage} />;
      default:
        return <MainPage onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;
